import type { DetailEndpoints } from "@/components/contact-history/types";

/** Lead-scoped transcript / email endpoints for a contact. The customer page
 * supplies a person-scoped builder; the rendering is otherwise shared. Lives
 * outside the component files so the contact sheet and the deal timeline can
 * both import it without breaking fast refresh. */
export function leadDetailEndpoints(leadId: string, base: "/leads" | "/deals" = "/leads"): DetailEndpoints {
  return (contactId) => ({
    transcriptUrl: `${base}/${leadId}/contacts/${contactId}/transcript`,
    emailUrl: `${base}/${leadId}/contacts/${contactId}/email`,
    audioUrl: `${base}/${leadId}/contacts/${contactId}/audio`,
  });
}
